import Repository from './Repository'

const action = 'documents'

export default {
  getList(id) {
    return Repository.get(action + '?response_id=' + id)
  },
  postItem(data) {
    return Repository.post(action, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  updateItem(id, data) {
    return Repository.post(`${action}/${id}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  deleteItem(id) {
    return Repository.delete(`${action}/${id}`)
  },
}
